import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Loader from "../components/Loader/Loader";

interface Props {
  children: React.ReactNode;
  // `| undefined` per exactOptionalPropertyTypes — RouteLogic passes
  // `route.role` which is optional in IRoute, so callers explicitly
  // hand us `undefined` for routes without a role requirement.
  role?: "Admin" | "User" | undefined;
}

export default function ProtectedRoute({ children, role }: Props) {
  const { loadingAuth, isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  if (loadingAuth) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
  }

  if (role === "Admin" && !isAdmin()) {
    return <Navigate to="/forbidden" replace />;
  }

  return <>{children}</>;
}
